import React from 'react';

import { formatNumber } from 'js/components/shared/vehicleFunctions';
import { formatDate } from 'Functions';

import { priceTypes } from 'components/rentingRedRac/types';

import 'css/components/rentingRedRac/PriceCard.css';
import register from 'registerServiceWorker';

const PriceCard = ({ item: prices }) => {
    const renderColumn = (content, classes = '') => (
        <td
            className={`${
                prices?.IsActivePrice ? 'u-bg-brand u-text-pale' : ''
            } ${classes} u-pv`}
        >
            {content}
        </td>
    );
    const alignNumbers = number => {
        const decimalIndex = number?.indexOf(',');
        return (
            <div
                style={{
                    width: '7em',
                }}
            >
                <span
                    style={{
                        float: 'left',
                        textAlign: 'right',
                        width: '4em',
                    }}
                >
                    {number.slice(0, decimalIndex)}
                </span>
                <span
                    style={{
                        float: 'right',
                        textAlign: 'left',
                        width: '3em',
                    }}
                >
                    {number.slice(decimalIndex)}
                </span>
            </div>
        );
    };
    return (
        <tr>
            {renderColumn(formatDate(prices?.FromDate))}
            {renderColumn(
                `${formatNumber(prices?.AmountWithTaxes.toFixed(2))}€`
            )}
            {renderColumn(`${prices?.OwnershipChange}€`)}
            {renderColumn(
                prices?.GuaranteeAmount
                    ? alignNumbers(
                          `${formatNumber(prices?.GuaranteeAmount.toFixed(2))}€`
                      )
                    : '-'
            )}
            {renderColumn(
                `${formatNumber(
                    (
                        prices?.AmountWithTaxes +
                        prices?.OwnershipChange +
                        (prices?.GuaranteeAmount || 0)
                    ).toFixed(2)
                )}€`,
                `${
                    prices?.IsActivePrice
                        ? 'u-bg-brand'
                        : 'u-bg-alternative-darken'
                } u-text-center`
            )}
        </tr>
    );
};

PriceCard.propTypes = {
    item: priceTypes,
};

export default PriceCard;
